import { render, staticRenderFns } from "./platFormOrder.vue?vue&type=template&id=57c7fabd&scoped=true&"
import script from "./platFormOrder.vue?vue&type=script&lang=js&"
export * from "./platFormOrder.vue?vue&type=script&lang=js&"
import style0 from "./platFormOrder.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./platFormOrder.vue?vue&type=style&index=1&id=57c7fabd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57c7fabd",
  null
  
)

export default component.exports